// 公共
import Mistake from '@/views/common/Mistake.vue';
import NoAuth from '@/views/common/NoAuth.vue';
import NotFound from '@/views/common/NotFound.vue';
import Entrance from '@/views/common/Entrance.vue';
import Blank from '@/views/common/Blank.vue';
import MenuManage from '@/views/common/MenuManage.vue';

const routes = [
  {
    path: '/menu_manage',
    name: 'MenuManage',
    component: MenuManage
  },
  {
    path: '/blank',
    name: 'Blank',
    component: Blank
  },
  {
    path: '/entrance',
    name: 'Entrance',
    component: Entrance
  },
  {
    path: '/mistake',
    name: 'Mistake',
    component: Mistake
  },
  {
    path: '/no_auth',
    name: 'NoAuth',
    component: NoAuth
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
];

export default routes;